export enum PrimaryGreen {
  GREEN_1 = "#003d15",
  GREEN_2 = "#00521d",
  GREEN_3 = "#007028",
  GREEN_4 = "#008f32",
  GREEN_5 = "#1db954",
  GREEN_6 = "#20cb5c",
  GREEN_7 = "#2cdd80",
  GREEN_8 = "#58e49b",
  GREEN_9 = "#84ebb5",
  GREEN_10 = "#caf6df",
  GREEN_11 = "#eefcf4",
}

export enum PrimaryGray {
  GRAY_1 = "#0f0f0f",
  GRAY_2 = "#1f1f1f",
  GRAY_3 = "#2e2e2e",
  GRAY_4 = "#3d3d3d",
  GRAY_5 = "#4d4d4d",
  GRAY_6 = "#5c5c5c",
  GRAY_7 = "#6b6b6b",
  GRAY_8 = "#7a7a7a",
  GRAY_9 = "#8a8a8a",
  GRAY_10 = "#999999",
  GRAY_11 = "#a8a8a8",
  GRAY_12 = "#b8b8b8",
  GRAY_13 = "#c7c7c7",
  GRAY_14 = "#d6d6d6",
  GRAY_15 = "#e6e6e6",
  GRAY_16 = "#f5f5f5",
  GRAY_17 = "#F7F9F5",
}

export enum SecondaryPurple {
  PURPLE_1 = "#1a004d",
  PURPLE_2 = "#220066",
  PURPLE_3 = "#330099",
  PURPLE_4 = "#4b00cc",
  PURPLE_5 = "#661aff",
  PURPLE_6 = "#7e33ff",
  PURPLE_7 = "#9e66ff",
  PURPLE_8 = "#c599ff",
  PURPLE_9 = "#e7ccff",
  PURPLE_10 = "#f6e5ff",
}

export enum SecondaryYellow {
  YELLOW_1 = "#474100",
  YELLOW_2 = "#665e00",
  YELLOW_3 = "#857a00",
  YELLOW_4 = "#a39600",
  YELLOW_5 = "#c2b200",
  YELLOW_6 = "#e0ce00",
  YELLOW_7 = "#fae500",
  YELLOW_8 = "#ffef3d",
  YELLOW_9 = "#fff370",
  YELLOW_10 = "#fff8ad",
  YELLOW_11 = "#fffcd6",
}

export enum SecondaryOrange {
  ORANGE_1 = "#8f3200",
  ORANGE_2 = "#c24400",
  ORANGE_3 = "#e65100",
  ORANGE_4 = "#ef6c00",
  ORANGE_5 = "#f57c00",
  ORANGE_6 = "#fb8c00",
  ORANGE_7 = "#ff9800",
  ORANGE_8 = "#ffa726",
  ORANGE_9 = "#ffb74d",
  ORANGE_10 = "#ffcc80",
  ORANGE_11 = "#ffe0b2",
  ORANGE_12 = "#fff3e0",
}

export enum TertiaryRed {
  RED_1 = "#7b0300",
  RED_2 = "#a3000e",
  RED_3 = "#cc0300",
  RED_4 = "#f50400",
  RED_5 = "#ff332e",
  RED_6 = "#ff5452",
  RED_7 = "#ff7370",
  RED_8 = "#ff9999",
  RED_9 = "#ffbdbd",
  RED_10 = "#ffd6d6",
  RED_11 = "#ffe8e8",
  RED_50 = "#FAE6E6",
  RED_600 = "#BB0202",
  FORM_ERROR = "#cd0202",
}

export enum TertiaryMagenta {
  MAGENTA_1 = "#5c0048",
  MAGENTA_2 = "#7a005f",
  MAGENTA_3 = "#990077",
  MAGENTA_4 = "#c20097",
  MAGENTA_5 = "#e000af",
  MAGENTA_6 = "#ff1fce",
  MAGENTA_7 = "#ff47d7",
  MAGENTA_8 = "#ff70e2",
  MAGENTA_9 = "#ff99eb",
  MAGENTA_10 = "#ffb8f1",
  MAGENTA_11 = "#ffd6f7",
  MAGENTA_12 = "#ffebfb",
}

export enum TertiaryCyan {
  CYAN_1 = "#002929",
  CYAN_2 = "#003d3d",
  CYAN_3 = "#005c5c",
  CYAN_4 = "#007a7a",
  CYAN_5 = "#008f8f",
  CYAN_6 = "#00b8b8",
  CYAN_7 = "#00e0e0",
  CYAN_8 = "#33ffff",
  CYAN_9 = "#70ffff",
  CYAN_10 = "#adffff",
  CYAN_11 = "#d6ffff",
  CYAN_12 = "#ebffff",
}

export enum TertiaryLime {
  LIME_1 = "#2a3d00",
  LIME_2 = "#375200",
  LIME_3 = "#537a00",
  LIME_4 = "#618f00",
  LIME_5 = "#7db800",
  LIME_6 = "#9feb00",
  LIME_7 = "#acff00",
  LIME_8 = "#c1ff3d",
  LIME_9 = "#d1ff70",
  LIME_10 = "#e5ffad",
  LIME_11 = "#f3ffd6",
}

export enum TertiaryBlue {
  BLUE_1 = "#002152",
  BLUE_2 = "#00317a",
  BLUE_3 = "#0041a3",
  BLUE_4 = "#0056d6",
  BLUE_5 = "#0066ff",
  BLUE_6 = "#297fff",
  BLUE_7 = "#5297ff",
  BLUE_8 = "#7aafff",
  BLUE_9 = "#99c2ff",
  BLUE_10 = "#b8d4ff",
  BLUE_11 = "#d6e6ff",
  BLUE_12 = "#eaf2ff",
  BLUE_13 = "#f3f8ff",
}

export enum GrayscaleBlack {
  BLACK_1 = "#606060",
  BLACK_2 = "#404040",
  BLACK_3 = "#303030",
  BLACK_4 = "#202020",
  BLACK_5 = "#101010",
}

export enum TertiaryGreen {
  GREEN_700 = "#005D49",
  GREEN_50 = "#E6F3F0",
}

export const LIGHT_GRAY = "#F7F9FA";
export const WHITE = "#FFFFFF";
export const BLACK = "#000000";
